import script from "./VideoWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoWidget.vue?vue&type=script&setup=true&lang=ts"

import "./VideoWidget.vue?vue&type=style&index=0&id=505d5cc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-505d5cc2"]])

export default __exports__